// styling
import styles from "./style.module.scss";

// components
import { NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";
import GradientBtn from "@ui/GradientBtn";
import Avatar from "@ui/Avatar";
import AnimatedText from "react-animated-text-content";
import Spring from "@components/Spring";
import ReactGA from "react-ga4";

// assets
import video from "@assets/home/hero/particles.mp4";

// data placeholder
import hero from "@db/hero";
import { Typography } from "@mui/material";
import Ticker from "@components/Ticker";

const Hero = () => {
  const token = localStorage.getItem("token");
  const handleGoogleAnalytics=(type)=>{
    console.log(type)
    ReactGA.event({
      category: 'Account Creation',
      action: 'Click',
      label: type,
  });
  }
  return (
   <>
    <section className={styles.hero}>
      <video
        src={video}
        className={styles.video}
        autoPlay
        loop
        muted
        disablePictureInPicture
        playsInline
        controls={false}
      />
      <div className={`${styles.hero_container} container`}>
        <div className={`${styles.media} bg-secondary border-hover`}>
          <Swiper
            className={styles.media_slider}
            loop={true}
            modules={[Pagination, EffectFade, Autoplay]}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            slidesPerView="auto"
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
            }}
            autoplay={{
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={1300}
            pagination={{
              clickable: true,
              horizontalClass: styles.pagination,
            }}
          >
            {hero.map((item, index) => (
              <SwiperSlide key={item.id}>
                <div className="d-flex flex-column g-30">
                  <div>
                    <img
                      className="border-10"
                      src={item.image}
                      alt={item.title}
                    />
                  </div>
                  <div className="d-flex flex-column g-5">
                    <NavLink className="h4 link-hover">{item.title}</NavLink>
                    <div className="d-flex align-items-center g-10">
                      <Avatar
                        src={item.author.avatar}
                        isVerified={item.author.isVerified}
                        alt={item.author.name}
                        size="xs"
                      />
                      <NavLink className="text-sm text-light text-bold link-hover">
                        @{item.author.name}
                      </NavLink>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className={styles.main}>
          <AnimatedText
            type="words"
            animationType="throw"
            duration={0.5}
            tag="h1"
            includeWhiteSpaces
          >
            Comix Creation

          </AnimatedText>
          <AnimatedText
            type="words"
            animationType="throw"
            duration={0.5}
            tag="h1"
            includeWhiteSpaces
          >

            Made Easy
          </AnimatedText>
          <Spring delay={600}>
            <p className={styles.main_text}>
              Create the story of tomorrow: UE COMIX is the ultimate platform
              for crafting original comics, manga and graphics novels.
            </p>
          </Spring>
          <div
            className={styles.main_buttons}
            style={{ flexDirection: "column" ,textAlign:"center"}}
          >
            <div onClick={()=>handleGoogleAnalytics("Sign Up")}>

            <Spring delay={800}>

              <GradientBtn href="/signup" className={"buttonCasses"}>
              <Typography variant="h6" style={{fontWeight:700}}>Create an Account</Typography>
              </GradientBtn>
            </Spring>
            </div>
            <Spring delay={800}>
              <p style={{fontWeight:700,fontSize:"16px",color:"white"}}>No Credit Card Needed</p>
            </Spring>
          </div>
        </div>
      </div>
    </section>
     <Ticker text="Your Story Starts Here" />
   </>
  );
};

export default Hero;
